module.exports = __webpack_public_path__ + "media/images/icons/outlined/alibaba-8d507c0b777ca1ac34df82949b8811f0.svg";